import colours from './colours'

const typography = {
  paragraph: {
    fontFamily: 'Montserrat, sans-serif',
    color: colours.primaryFont
  },
  mainHeading: {
    fontFamily: 'Helvetica Light, sans-serif',
    color: colours.primaryFont
  }
}

export default typography